export default function SearchIcon({
  width = '18',
  height = '18',
  ...props
}: React.SVGProps<SVGSVGElement> & { width?: string; height?: string }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.71429 12.4286C9.8702 12.4286 12.4286 9.8702 12.4286 6.71429C12.4286 3.55837 9.8702 1 6.71429 1C3.55837 1 1 3.55837 1 6.71429C1 9.8702 3.55837 12.4286 6.71429 12.4286Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0807 17.0001L10.7139 10.7144"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
